import React from "react";
import Layout from "../../components/layout";

const Modifyclient = () => {
  return <>Modifyclient</>;
};

export default Modifyclient;
